// Your sample library (flask sample_library.py): a private, non-looping
// session keyed samples:<username>, titled "<Name>'s samples", where audio
// dropped anywhere on the page lands (Liam, 2026-11-03). Mine shows it first
// (/sessions?include_library=1); every other list, and the app, leave it out.
//   isLibraryName(name), isLibrary(session)
//   ensureLibrary()   -> Promise<{ name, title }> (made on first ask)
//   libraryTitle(session)
import { apiGet } from "@/services/api/client.js";

export const LIBRARY_PREFIX = "samples:";

export const isLibraryName = (name) =>
  typeof name === "string" && name.startsWith(LIBRARY_PREFIX);

export const isLibrary = (session) =>
  !!session &&
  isLibraryName(session.name) &&
  session.name === `${LIBRARY_PREFIX}${session.creator}`;

export function libraryTitle(session) {
  const alt =
    session && typeof session.alt_name === "string"
      ? session.alt_name.trim()
      : "";
  if (alt) return alt;
  const who = session && session.creator;
  return who ? `${who}'s samples` : "Your samples";
}

// One request per account per page: the drop handler asks every time.
let cached = { user: null, promise: null };

export function ensureLibrary(username) {
  if (cached.user === username && cached.promise) return cached.promise;
  const promise = apiGet("/library_session").then((doc) => {
    if (!doc || !doc.name) throw new Error("no library");
    return { name: doc.name, title: libraryTitle(doc) };
  });
  cached = { user: username, promise };
  // A failure isn't remembered: the next drop asks again.
  promise.catch(() => {
    if (cached.promise === promise) cached = { user: null, promise: null };
  });
  return promise;
}

// Signing out, or in as someone else.
export function forgetLibrary() {
  cached = { user: null, promise: null };
}
